<div ngbAutoFocus class="w-100 h-100 d-flex flex-column">
    <div>
        @if (storageAccountIsDown) {
<storage-account-down-toast></storage-account-down-toast>
}
        <ups-header class="flex-grow-1"></ups-header>
    </div>
    <div class="main-content flex-grow-1 container-1">
        @if (type === 'details') {
<request-details #internalComponent [requestId]="requestId"></request-details>
}
        @if (type === 'edit') {
<request-form #internalComponent [requestId]="requestId"></request-form>
}
        @if (type === 'user-access-history') {
<user-access-history #internalComponent></user-access-history>
}
        @if (type === 'notification-settings') {
<notification-settings #internalComponent></notification-settings>
}
    </div>
    <div>
        <ups-footer class="flex-grow-1 m-0"></ups-footer>
    </div>
</div>